import { render, staticRenderFns } from "./ButtonGroupTab.vue?vue&type=template&id=6e0c47d8&scoped=true&"
import script from "./ButtonGroupTab.vue?vue&type=script&lang=js&"
export * from "./ButtonGroupTab.vue?vue&type=script&lang=js&"
import style0 from "./ButtonGroupTab.vue?vue&type=style&index=0&id=6e0c47d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0c47d8",
  null
  
)

export default component.exports